import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getEnvelopePrintingOptionPageTag = (options: DefaultProductOptions) => {
  const level2 = 'Envelope Option';
  const modalEvent = [];
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, level2, modalEvent, options.projectID);

  const newModal = {
    ...modal,
    messages: [{ statusMessages: '' }],
  };

  return {
    modal: newModal,
    product,
    user,
  };
};
